import huntingPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/huntingPizzaHubImage.webp';
import margarittaPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/margarittaPizzaHubImage.webp';
import havaianPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/havaianPizzaHubImage.webp';
import trianglesHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/trianglesHubImage.webp';
import batonHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/batonHubImage.webp';
import cheeseMuffinsHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/cheeseMuffinsHubImage.webp';

export const RecipesHubArrRu = {
    metaTitle: "рецепты Pastoral",
    metaDescription: "разнообразные рецепты Pastoral для Вашей кухни",
    recipes: [
        {
            link: "hunting-pizza",
            image: huntingPizzaHubImage,
            title: "Пицца Охотничья",
            description: "Пицца Охотничья — это вкусное блюдо с хрустящим коржом, щедро смазанным томатным соусом и оливками. Ее начинка включает ароматную охотничью колбасу, маринованные огурцы...",
        },
        {
            link: "margaritta-pizza",
            image: margarittaPizzaHubImage,
            title: "Пицца «Маргарита»",
            description: "Пицца «Маргарита» — это легендарное блюдо итальянской кухни, основой которого является тонкое тесто, покрытое ароматным томатным соусом, нежной моцареллой и свежими листочками базилика",
        },
        {
            link: "havaian-pizza",
            image: havaianPizzaHubImage,
            title: "Пицца «Гавайская»",
            description: "Гавайская пицца — это неповторимое сочетание итальянской классики с экзотическим тропическим акцентом. Её основу составляет тонкое тесто, покрытое сочным томатным соусом...",
        },
        {
            link: "triangles",
            image: trianglesHubImage,
            title: "Треугольники",
            description: "Треугольники — это аппетитные хрустящие пирожки с нежной, сочной начинкой, скрытой внутри тонкого теста. Гармония расплавленного твёрдого сыра и ароматного мяса создаёт взрыв вкусов",
        },
        {
            link: "baton",
            image: batonHubImage,
            title: "Батон",
            description: "Батон — это аппетитный хлеб продолговатой формы с нежной, воздушной мякотью и хрустящей золотистой корочкой. Его аромат во время выпечки наполняет дом уютом",
        },
        {
            link: "Cheese-muffins",
            image: cheeseMuffinsHubImage,
            title: "Сырные кексы",
            description: "Сырные кексы — это лёгкие и нежные десерты, которые буквально тают во рту благодаря своей воздушной, пышной структуре...",
        },
    ]
}